interface MapIconStaticProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
  strokeWidth?: number;
}

export const MapIconStatic = ({
  width = 107,
  height = 107,
  className,
  color = 'currentColor',
  strokeWidth = 8
}: MapIconStaticProps) => {
  // Original paths from MapIcon.tsx (normal state)
  const mainPath =
    'M34.738 89.8862L21.7587 96.9387C15.9357 100.103 8.84766 95.8872 8.84766 89.2601L8.84766 32.1648C8.84766 28.651 10.7461 25.4113 13.8116 23.6938L32.7013 13.1108C36.4591 11.0055 40.9559 10.6715 44.9835 12.1985L64.2469 19.5019C66.8909 20.5043 69.8404 20.3044 72.325 18.9544L85.2824 11.9138C91.1054 8.74982 98.1934 12.9653 98.1934 19.5923V76.6636C98.1934 80.1902 96.2812 83.4396 93.1982 85.152L74.2906 95.6535C70.5604 97.7253 66.1094 98.0572 62.1132 96.5614L42.7775 89.3242C40.1428 88.3381 37.2099 88.5431 34.738 89.8862Z';
  const verticalLine1 = 'M38.6289 13.1265L38.6289 86.1999';
  const verticalLine2 = 'M68.4102 95.8925V22.0605';

  return (
    <div className={className} style={{ width, height }}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 107 108"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Main path */}
        <path
          d={mainPath}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Vertical line 1 */}
        <path
          d={verticalLine1}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Vertical line 2 */}
        <path
          d={verticalLine2}
          stroke={color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}; 